<script>
    import {
        getFormatDate,
        goToURL,
    } from "../../../Utils/utilFunctions.svelte";

    export let invoiceDetails = {};

    $: isInvoiceCancelled = invoiceDetails.status == Number(9);

    const handleClickEncounterID = () => {
        const { patientEncounterId } = invoiceDetails;

        goToURL(`/PatientEncounter/view/${patientEncounterId}/tab=billing`);
    };
</script>

<div class="flex justify-between">
    <div class="flex items-center gap-x-4">
        <p>
            <span class="font-bold">Invoice ID:</span>
            {invoiceDetails.id} for Encounter ID
            <span
                class="underline cursor-pointer hover:font-bold"
                on:click|preventDefault={handleClickEncounterID}
                >{invoiceDetails.patientEncounterId}</span
            >, <span class="font-bold">Invoice No.:</span>
            {invoiceDetails.invoiceNumber}
        </p>

        <p>
            <span class="font-bold">Due date:</span>
            {getFormatDate(invoiceDetails.dueDate)}
        </p>

        {#if isInvoiceCancelled}
            <div
                class="badge badge-warning py-4 cursor-default text-white font-extrabold tracking-[0.25rem]"
            >
                CANCELLED
            </div>
        {/if}
    </div>
</div>
